import { LookupEntity } from 'pco-product-service-internal-consumer';

export type FilteredDataType = {
  data?: LookupEntity[];
  searchTerm: string;
};
export const searchSuggestionFilterData = ({ data, searchTerm }: FilteredDataType) => {
  if (!data) {
    return [];
  }
  const suggestion = searchTerm.toLowerCase();
  const filteredData = data?.filter((item) => {
    return item?.value?.label?.toLowerCase().includes(suggestion);
  });
  return filteredData;
};
